import { api } from "./api"

export async function GetUserStatus() {
    return api.get("/users/status").then((res) => { return res.data })
}